import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_30.module.css";
import { Link } from "@mui/material";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter31.json";
import Common_html from "./Common_html";

export default function Chapter_31() {
  //   const corosalref = useRef()

  //   useEffect(()=>{
  //     if(corosalref.current)
  //     {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent",corosalref.current);
  // },[corosalref.current])
  return (
    <>
      <Head>
        <title>MEGAVERSE AND ORTHODOX | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXI"
        ></meta>
        <meta
          property="og:title"
          content="MEGAVERSE AND ORTHODOX | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An expansive cosmic landscape merging with traditional spiritual symbols, representing the convergence of the Megaverse and Orthodox beliefs. The image illustrates the vastness of the multiverse alongside ancient spiritual doctrines, symbolizing the integration of infinite realities with time-honored wisdom."></meta>
        <meta
          property="og:description"
          content="Uncover the Central Doctrine on the Megaverse and Orthodox perspectives, where expansive cosmic realities meet traditional spiritual beliefs. Explore the intricate relationship between the infinite multiverse and established spiritual doctrines, and how they converge to expand our understanding of existence."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=31"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An expansive cosmic landscape merging with traditional spiritual symbols, representing the convergence of the Megaverse and Orthodox beliefs. The image illustrates the vastness of the multiverse alongside ancient spiritual doctrines, symbolizing the integration of infinite realities with time-honored wisdom."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=31"></meta>
        <meta name="twitter:title" content="MEGAVERSE AND ORTHODOX | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Uncover the Central Doctrine on the Megaverse and Orthodox perspectives, where expansive cosmic realities meet traditional spiritual beliefs. Explore the intricate relationship between the infinite multiverse and established spiritual doctrines, and how they converge to expand our understanding of existence."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=31" />
      </Head>


       <Common_html BlockData={BlockData} />
    </>
  );
}
